import './BetbookReactions.less';

import clsx from 'clsx';
import React from 'react';

import ThumbUpIcon from '@/icons/ThumbUpIcon';
import CommentIcon from '@/icons/CommentIcon';
import { ReactionButton } from '@/betbook/components/betbook-reactions/ReactionButton';

function BetbookCommentReactions({
    className,
    commentCount,
    customerComment,
    isInDetail,
    onRatingClick,
    onCommentClick,
    own,
    ratings
}) {
    const { currentUserRating, positive = 0 } = ratings || {};
    return (
        <div className={clsx('betbook-reactions fs-14 flex flex-row justify-around', className)}>
            <div className="flex items-center flex-1 pt-2">
                <ReactionButton
                    isInDetail={isInDetail}
                    count={positive}
                    onClick={e => onRatingClick(e, 'POSITIVE', currentUserRating)}
                    active={currentUserRating === 'POSITIVE'}
                    icon={ThumbUpIcon}
                    disabled={own}
                    data-atid="comment-reaction-thumb-up"
                />
                <ReactionButton
                    isInDetail={isInDetail}
                    count={commentCount}
                    onClick={onCommentClick && onCommentClick}
                    active={customerComment}
                    icon={CommentIcon}
                    data-atid="comment-reaction-comment"
                />
            </div>
        </div>
    );
}

export default BetbookCommentReactions;
